<template>
    <div class="">
        <div v-if="!enable" style="position: absolute; width: 100%; height:10000px; left: 0; right: 0; opacity: 0.8; z-index: 99;"></div>
      <div v-if="loading" class="container">
        <div class="row">
          <div class="col-12 text-center mt-5">
            <div class="text-center">
                <div class="row d-flex justify-content-center">
                    <idx-skeleton height="35" width="100" class="m-2 mb-4" radius="6" />
                </div>
                <idx-skeleton height="14" class="m-2" radius="6" />
                <idx-skeleton height="14" class="m-2" radius="6" />
                <div class="row text-center d-flex justify-content-center">
                    <idx-skeleton height="35" width="35" class="m-2" radius="8" v-for="item in [0,1,2,3,4,5,6,7,8,9]" :key="item" />
                </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="displayClosingMessage" class="container">
        <div
          v-if="researchInfo.closingMessageEnabled && closingMessage.html"
          class="row"
        >
          <div class="col-12">
            <div v-if="closingMessage.useLogo" class="row">
              <div class="col-12 mt-3">
                <div class="text-center">

                  <img :src="logo" style="height: 75px; max-width: 100%;" />

                </div>
              </div>
            </div>

            <div class="row">
              <div
                class="col-12 mb-4 mt-4 closing-message-area"
                v-html="closingMessage.html"
              />
            </div>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-12 text-center mt-4 closing-message-area">
            <span><i class="far fa-smile"></i></span>
            <h4 class="mt-4">
              {{ $t('researchPage.title') }}
            </h4>
            <span>
              {{ $t('researchPage.firstMsg') }}
            </span>
            <span>
              {{ $t('researchPage.secondMsg') }}
            </span>
          </div>
        </div>
      </div>
      <div v-else-if="error" class="container">
        <div class="row">
          <div class="col-12 text-center mt-4 error-area">
            <span><i class="far fa-smile"></i></span>
            <h4 class="mt-4">
              {{ $t('researchPage.title') }}
            </h4>
            <span>{{ error }}</span>
          </div>
        </div>
      </div>
      <div v-else-if="researchInfo.action.paused" class="container">
        <Unavailable />
      </div>
      <div
        v-else
        class="container"
        :style="{
          backgroundColor:
            researchInfo.action.email.template.scale !== 'colors'
              ? researchInfo.action.email.template.background
              : '#ffffff',
        }"
      >
        <div class="pt-2" v-if="researchInfo.enableTranslation">
          <b-button-group>
            <b-button
              v-if="researchInfo.action.email.template.enableMyHTMLPt"
              class="btn"
              @click="setLangView('br')"
              :variant="langView === 'br' ? 'primary' : ''"
              ><country-flag country="br" size="normal"
            /></b-button>
            <b-button
              v-if="researchInfo.action.email.template.enableMyHTMLEn"
              class="btn"
              @click="setLangView('us')"
              :variant="langView === 'us' ? 'primary' : ''"
              ><country-flag country="us" size="normal"
            /></b-button>
            <b-button
              v-if="researchInfo.action.email.template.enableMyHTMLEs"
              class="btn"
              @click="setLangView('es')"
              :variant="langView === 'es' ? 'primary' : ''"
              ><country-flag country="es" size="normal"
            /></b-button>
          </b-button-group>
        </div>

        <div v-if="researchInfo.useLogo" class="row">
          <div class="col-12 mt-3">
            <div class="text-center">
              <img :src="logo" style="height: 75px; max-width: 100%" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div id="body-email-modal" class="mt-3 mb-4" v-html="text" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <template v-if="questionHTML">
              <div class="text-center">
                <div v-html="questionHTML"></div>
              </div>
            </template>
            <template v-else>
              <div class="text-center">
                {{ question }}
              </div>
            </template>
            <methodology
              :textColor="
                researchInfo.action.email.template.scale !== 'colors'
                  ? researchInfo.action.email.template.backgroundtext
                  : '#000000'
              "
              :lang="langView"
              :surveySelectedColor="
                researchInfo.action.email.template.templatebuttonselected
              "
              :surveyTextColor="researchInfo.action.email.template.grade"
              :surveyBorderColor="researchInfo.action.email.template.border"
              :surveyColor="researchInfo.scale"
              :actionMetric="researchInfo.metric"
              :isLinkQrCode="false"
              class="mt-4 mb-3"
            />
          </div>
        </div>

        <div v-if="researchInfo.commentPosition === 'up'" class="row mb-4">
          <div class="col-12">
            <div class="feedback-area mt-4" v-if="langView === 'br'">
              <research-replys
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                :metric="researchInfo.metric"
                :promotersReply="promotersQuestion"
                :neutralReply="neutralQuestion"
                :detractorsReply="detractorsQuestion"
                :grade="testNpsReview"
              />
              <span v-if="displayRequiredFields" class="required mt-2">
                *Obrigatório
              </span>
              <textarea
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
            <div class="feedback-area mt-4" v-if="langView === 'us'">
              <research-replys
                :defaultFeedback="'What is the main reason for your grade?'"
                :metric="researchInfo.metric"
                :promotersReply="
                  researchInfo.action.reply.languageSupport.promotersEN
                "
                :neutralReply="
                  researchInfo.action.reply.languageSupport.neutralEN
                "
                :detractorsReply="
                  researchInfo.action.reply.languageSupport.detractorsEN
                "
                :grade="testNpsReview"
              />
              <span v-if="displayRequiredFields" class="required mt-2">
                *Required
              </span>
              <textarea
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
            <div class="feedback-area mt-4" v-if="langView === 'es'">
              <research-replys
                :defaultFeedback="'¿Cuál es la razón principal de tu calificación?'"
                :metric="researchInfo.metric"
                :promotersReply="
                  researchInfo.action.reply.languageSupport.promoterES
                "
                :neutralReply="
                  researchInfo.action.reply.languageSupport.neutraES
                "
                :detractorsReply="
                  researchInfo.action.reply.languageSupport.detractorES
                "
                :grade="testNpsReview"
              />
              <span v-if="displayRequiredFields" class="required mt-2">
                *Requerido
              </span>
              <textarea
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <hr v-if="researchInfo.additionalQuestions.length > 0" />
            <div v-for="(item, i) in researchInfo.additionalQuestions" :key="i">
              <div v-if="indicatorValuedQuestion(item)">
                <template v-if="item.profileEnabled">
                  <template
                    v-if="item.selectedProfile.includes(conditionalQuestion())"
                  >
                    <template
                      v-if="
                        promotersGrades.includes(testNpsReview) ||
                        detractorsGrades.includes(testNpsReview) ||
                        passivesGrades.includes(testNpsReview)
                      "
                    >
                      <!-- all mandatory questions -->
                      <span
                        v-if="displayRequiredFields && item.type !== 'LABEL'"
                        class="required"
                      >
                        *Obrigatório
                      </span>
                      <!-- -->

                      <!-- specific mandatory questions -->
                      <div
                        v-show="
                          showMessage &&
                          item.mandatory &&
                          item.type !== 'LABEL' &&
                          item.addQuestionAnswer &&
                          item.addQuestionAnswer.review === null
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>

                      <div
                        v-show="
                          showMessage &&
                          item.mandatory &&
                          item.type === 'MULTIPLE' &&
                          item.addQuestionAnswerMultiple &&
                          item.addQuestionAnswerMultiple.multipleValues &&
                          item.addQuestionAnswerMultiple.multipleValues
                            .length === 0
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>

                      <div
                        v-show="
                          (showMessage &&
                            item.mandatory &&
                            item.type === 'INPUT' &&
                            !item.answerText) ||
                          (item.answerText && item.answerText.review === null)
                        "
                      >
                        <span class="required"> *Obrigatório </span>
                      </div>
                      <!-- -->

                      <likert
                        :idQuestion="item.id"
                        v-if="item.type === 'LIKERT'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :lang="langView"
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        :commentEnabled="item.commentEnabled"
                        v-model="item.addQuestionAnswer"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      />
                      <c-sat
                        :idQuestion="item.id"
                        v-if="item.type === 'CSAT'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      />
                      <star-rating
                        :idQuestion="item.id"
                        v-if="item.type === 'REVIEWS'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      />
                      <like-dislike
                        :idQuestion="item.id"
                        v-if="item.type === 'LIKE/DISLIKE'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :questionText="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :index="i"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      />
                      <emotion
                        :idQuestion="item.id"
                        :item-id="i.toString()"
                        v-if="item.type === 'EMOTION'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :questionText="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :index="i"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      />
                      <multiple-choices
                        :id="item.id"
                        :idQuestion="item.id"
                        :item-id="i.toString()"
                        v-if="item.type === 'MULTIPLE'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :type="item.multipleType"
                        :questionText="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :choices="item.choices"
                        :index="i"
                        v-model="item.addQuestionAnswerMultiple"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        @input="getReview"
                        :lang="langView"
                      />
                      <ces
                        :idQuestion="item.id"
                        v-if="item.type === 'CES'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      />

                      <likertEmotion
                        :idQuestion="item.id"
                        v-if="item.type === 'LIKERT/EMOTION'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      />

                      <label-question
                        v-if="item.type === 'LABEL'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="item.text"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      />
                      <input-type
                        :id="item.id"
                        v-if="item.type === 'INPUT'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :index="i"
                        v-model="item.answerText"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                        :isMandatoryForQuestion="researchInfo.mandatory"
                        @input="getReview"
                      />
                      <nps
                        :idQuestion="item.id"
                        v-if="item.type === 'NPS'"
                        :textColor="
                          researchInfo.action.email.template.scale !== 'colors'
                            ? researchInfo.action.email.template.backgroundtext
                            : '#000000'
                        "
                        :text="
                          langView === 'br'
                            ? item.text
                            : langView === 'us'
                            ? item.textEN
                            : item.textES
                        "
                        :item-id="i.toString()"
                        :index="i"
                        :colorTemplate="researchInfo.scale"
                        v-model="item.addQuestionAnswer"
                        :commentEnabled="item.commentEnabled"
                        :applicableEnabled="item.applicableEnabled"
                        :addQuestionTemplate="researchInfo.addQuestionTemplate"
                      />
                    </template>
                  </template>
                </template>
                <template v-else>
                  <!-- all mandatory questions -->
                  <span
                    v-if="displayRequiredFields && item.type !== 'LABEL'"
                    class="required"
                  >
                    *Obrigatório
                  </span>
                  <!-- -->

                  <!-- specific mandatory questions -->
                  <div
                    v-show="
                      showMessage &&
                      item.mandatory &&
                      item.type !== 'LABEL' &&
                      item.addQuestionAnswer &&
                      item.addQuestionAnswer.review === null
                    "
                  >
                    <span class="required"> *Obrigatório </span>
                  </div>

                  <div
                    v-show="
                      showMessage &&
                      item.mandatory &&
                      item.type === 'MULTIPLE' &&
                      item.addQuestionAnswerMultiple &&
                      item.addQuestionAnswerMultiple.multipleValues &&
                      item.addQuestionAnswerMultiple.multipleValues.length === 0
                    "
                  >
                    <span class="required"> *Obrigatório </span>
                  </div>

                  <div
                    v-show="
                      (showMessage &&
                        item.mandatory &&
                        item.type === 'INPUT' &&
                        !item.answerText) ||
                      (item.answerText && item.answerText.review === null)
                    "
                  >
                    <span class="required"> *Obrigatório </span>
                  </div>
                  <!-- -->

                  <likert
                    v-if="item.type === 'LIKERT' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :lang="langView"
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />
                  <c-sat
                    v-if="item.type === 'CSAT' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />
                  <star-rating
                    v-if="item.type === 'REVIEWS' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />
                  <like-dislike
                    v-if="item.type === 'LIKE/DISLIKE' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :questionText="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :index="i"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :item-id="i.toString()"
                    :idQuestion="item.id"
                    @input="getReview"
                  />
                  <emotion
                    v-if="item.type === 'EMOTION' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :questionText="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :index="i"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :item-id="i.toString()"
                    :idQuestion="item.id"
                    @input="getReview"
                  />
                  <multiple-choices
                    :id="item.id"
                    v-if="item.type === 'MULTIPLE' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :type="item.multipleType"
                    :questionText="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :choices="item.choices"
                    :index="i"
                    v-model="item.addQuestionAnswerMultiple"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :item-id="i.toString()"
                    :idQuestion="item.id"
                    @input="getReview"
                    :lang="langView"
                  />
                  <ces
                    v-if="item.type === 'CES' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />

                  <likertEmotion
                    v-if="item.type === 'LIKERT/EMOTION' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />

                  <input-type
                    :id="item.id"
                    v-if="item.type === 'INPUT' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :index="i"
                    v-model="item.answerText"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :item-id="i.toString()"
                    :idQuestion="item.id"
                    :isMandatoryForQuestion="researchInfo.mandatory"
                    @input="getReview"
                  />
                  <label-question
                    v-if="item.type === 'LABEL' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :item-id="i.toString()"
                    :idQuestion="item.id"
                    @input="getReview"
                  />
                  <nps
                    v-if="item.type === 'NPS' && !item.show"
                    :textColor="
                      researchInfo.action.email.template.scale !== 'colors'
                        ? researchInfo.action.email.template.backgroundtext
                        : '#000000'
                    "
                    :text="
                      langView === 'br'
                        ? item.text
                        : langView === 'us'
                        ? item.textEN
                        : item.textES
                    "
                    :item-id="i.toString()"
                    :index="i"
                    :colorTemplate="researchInfo.scale"
                    v-model="item.addQuestionAnswer"
                    :commentEnabled="item.commentEnabled"
                    :applicableEnabled="item.applicableEnabled"
                    :addQuestionTemplate="researchInfo.addQuestionTemplate"
                    :idQuestion="item.id"
                    @input="getReview"
                  />
                  <template
                    v-if="item.displayType === 'formSearch' && !item.show"
                  >
                    <contact
                      v-if="item.type === 'CONTACT'"
                      :textColor="
                        researchInfo.action.email.template.scale !== 'colors'
                          ? researchInfo.action.email.template.backgroundtext
                          : '#000000'
                      "
                      :type="item.displayType"
                      :questionText="
                        langView === 'br'
                          ? item.text
                          : langView === 'us'
                          ? item.textEN
                          : item.textES
                      "
                      :choices="item.choices"
                      :index="i"
                      v-model="dataContact"
                    />
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div v-if="researchInfo.commentPosition === 'down'" class="row">
          <div class="col-12">
            <div class="feedback-area mt-4" v-if="langView === 'br'">
              <research-replys
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                :metric="researchInfo.metric"
                :promotersReply="promotersQuestion"
                :neutralReply="neutralQuestion"
                :detractorsReply="detractorsQuestion"
                :grade="testNpsReview"
              />
              <span v-if="displayRequiredFields" class="required mt-2">
                *Obrigatório
              </span>
              <textarea
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
            <div class="feedback-area mt-4" v-if="langView === 'us'">
              <research-replys
                :defaultFeedback="'What is the main reason for your grade?'"
                :metric="researchInfo.metric"
                :promotersReply="
                  researchInfo.action.reply.languageSupport.promotersEN
                "
                :neutralReply="
                  researchInfo.action.reply.languageSupport.neutralEN
                "
                :detractorsReply="
                  researchInfo.action.reply.languageSupport.detractorsEN
                "
                :grade="testNpsReview"
              />
              <span v-if="displayRequiredFields" class="required mt-2">
                *Required
              </span>
              <textarea
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
            <div class="feedback-area mt-4" v-if="langView === 'es'">
              <research-replys
                :defaultFeedback="'¿Cuál es la razón principal de tu calificación?'"
                :metric="researchInfo.metric"
                :promotersReply="
                  researchInfo.action.reply.languageSupport.promotersES
                "
                :neutralReply="
                  researchInfo.action.reply.languageSupport.neutralES
                "
                :detractorsReply="
                  researchInfo.action.reply.languageSupport.detractorsES
                "
                :grade="testNpsReview"
              />
              <span v-if="displayRequiredFields" class="required mt-2">
                *Requerido
              </span>
              <textarea
                v-model="feedback"
                name=""
                id="feedback"
                class="form-control"
                rows="4"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row pt-2" v-if="researchInfo.enableAnonymous">
          <b-form-checkbox
            :disabled="researchInfo.action.allAnswersAnonymous"
            class="check-alert-modal ml-3"
            id="id-anonymous"
            :style="{
              color:
                researchInfo.action.email.template.scale !== 'colors'
                  ? researchInfo.action.email.template.backgroundtext
                  : '#000000',
            }"
            v-model="anonymousResponse"
          >
          </b-form-checkbox>

          <label
            for="id-anonymous"
            style="margin-left: 15px;"
            :style="{
              color:
                researchInfo.action.email.template.scale !== 'colors'
                  ? researchInfo.action.email.template.backgroundtext
                  : '#000000',
            }"
            v-show="langView === 'br'"
          >
            {{ researchInfo.enableAnonymous }}
          </label>
          <label
            for="id-anonymous"
            style="margin-left: 15px;"
            :style="{
              color:
                researchInfo.action.email.template.scale !== 'colors'
                  ? researchInfo.action.email.template.backgroundtext
                  : '#000000',
            }"
            v-show="langView === 'us'"
          >
            {{ researchInfo.enableAnonymousEn }}
          </label>
          <label
            for="id-anonymous"
            style="margin-left: 15px;"
            :style="{
              color:
                researchInfo.action.email.template.scale !== 'colors'
                  ? researchInfo.action.email.template.backgroundtext
                  : '#000000',
            }"
            v-show="langView === 'es'"
          >
            {{ researchInfo.enableAnonymousEs }}
          </label>
        </div>
        <div v-if="enabledAudioResponse">
          <audio-recorder
            format="mp3"
            :bit-rate="128"
            upload-url="YOUR_API_URL"
            :attempts="1"
            :time="1"
            :headers="headers"
            :before-recording="callback"
            :pause-recording="callback"
            :after-recording="callback"
            :select-record="callback"
            :before-upload="callback"
            :successful-upload="callback"
            :failed-upload="callback"
          />
        </div>
        <div class="row mt-5">
          <div class="col-12 text-center mt-2 mb-3 btn-send">
            <template v-if="typeModalContact">
              <b-button
                v-b-modal.modal-send
                @click="submit"
                variant="btn btn-primary"
                >Enviar!</b-button
              >
              <template v-if="validateFields">
                <b-modal
                  id="modal-send"
                  hide-footer
                  hide-header
                  :no-close-on-backdrop="true"
                  hide-header-close
                >
                  <div class="row mt-2">
                    <div class="col-12">
                      <div
                        v-for="(item, i) in researchInfo.additionalQuestions"
                        :key="i"
                      >
                        <contact
                          v-if="item.type === 'CONTACT'"
                          :type="item.displayType"
                          :questionText="
                            langView === 'br'
                              ? item.text
                              : langView === 'us'
                              ? item.textEN
                              : item.textES
                          "
                          :choices="item.choices"
                          :index="i"
                          v-model="dataContact"
                        />
                      </div>
                    </div>
                  </div>
                  <b-button
                    class="mt-3"
                    block
                    variant="btn btn-primary"
                    @click="updateContactInfo"
                    >Enviar</b-button
                  >
                </b-modal>
              </template>
            </template>
            <template v-else>
              <div v-if="researchInfo.submitButtonEnabled">
                <button
                  :disabled="loadingSubmit"
                  :style="{
                    boxShadow: `0px 10px 30px -7px ${
                      researchInfo.action.email.template.buttonColor ||
                      '#cccccc'
                    }`,
                    backgroundColor: researchInfo.action.email.template
                      .buttonColor
                      ? researchInfo.action.email.template.buttonColor
                      : '',
                    borderColor: researchInfo.action.email.template
                      .buttonBorderColor
                      ? researchInfo.action.email.template.buttonBorderColor
                      : '',
                    color: researchInfo.action.email.template.buttonTextColor
                      ? researchInfo.action.email.template.buttonTextColor
                      : '',
                  }"
                  class="btn btn-primary px-5 py-2"
                  @click="submit"
                >
                  <span v-show="langView === 'br'">
                    {{
                      researchInfo.action.email.template.submitButtonValue ||
                      $t('researchPage.send')
                    }}
                  </span>
                  <span v-show="langView === 'us'">
                    {{
                      researchInfo.action.email.template.submitButtonValueEn ||
                      $t('researchPage.send')
                    }}
                  </span>
                  <span v-show="langView === 'es'">
                    {{
                      researchInfo.action.email.template.submitButtonValueEs ||
                      $t('researchPage.send')
                    }}
                  </span>
                </button>
              </div>
              <div v-else>
                <button
                  :disabled="loadingSubmit"
                  class="btn btn-primary px-5 py-2 btn-shadow"
                  @click="submit"
                >
                  {{ $t('researchPage.send') }}
                </button>
              </div>
            </template>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center mt-5">
            <hr />
            <div
              class="template-footer-modal mt-4 mb-4"
              v-if="researchInfo.footer"
            >
              <a href="https://www.indecx.com.br/">
                <img
                  src="../../../assets/logo-indecx.png"
                  style="width: 80px;"
                />
              </a>
            </div>
          </div>
        </div>
        <div v-if="researchInfo.textprivacyPolicy" class="row">
          <div class="col-12 text-center mb-4">
            <span style="font-size: 0.9em;" v-show="langView === 'br'"
              ><a
                :href="researchInfo.linkprivacyPolicy"
                style="color: #212529;"
                target="_blank"
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                >{{ researchInfo.textprivacyPolicy }}</a
              ></span
            >
            <span style="font-size: 0.9em;" v-show="langView === 'us'"
              ><a
                :href="researchInfo.linkprivacyPolicy"
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                target="_blank"
                >{{ researchInfo.textprivacyPolicyEn }}</a
              ></span
            >
            <span style="font-size: 0.9em;" v-show="langView === 'es'"
              ><a
                :href="researchInfo.linkprivacyPolicy"
                :style="{
                  color:
                    researchInfo.action.email.template.scale !== 'colors'
                      ? researchInfo.action.email.template.backgroundtext
                      : '#000000',
                }"
                target="_blank"
                >{{ researchInfo.textprivacyPolicyEs }}</a
              ></span
            >
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import CountryFlag from 'vue-country-flag';
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import Spinner from 'vue-spinkit';
import swal from 'sweetalert';
import bowser from 'bowser';
import cSat from '@/components/molecules/metrics/csat';
import nps from '@/components/molecules/metrics/nps';
import ces from '@/components/molecules/metrics/ces';
import likert from '@/components/molecules/metrics/likert';
import starRating from '@/components/molecules/metrics/reviews';
import likeDislike from '@/components/molecules/metrics/like-dislike';
import emotion from '@/components/molecules/metrics/emotion';
import multipleChoices from '@/components/molecules/metrics/multiple-choices';
import inputType from '@/components/molecules/metrics/input-type';
import likertEmotion from '@/components/molecules/metrics/likert-emotion';
import contact from '@/components/molecules/metrics/contact';
import labelQuestion from '@/components/molecules/metrics/label-question';
import methodology from '@/components/molecules/action-templates/methodology';
import researchReplys from '@/components/atoms/research-replys';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import validator from 'validator';
import api from '../../../services/api';
import EventBus from '../../../eventBus';

export default {
    name: 'ResearchCall',
    components: {
    methodology,
    cSat,
    nps,
    likert,
    starRating,
    likeDislike,
    emotion,
    multipleChoices,
    inputType,
    contact,
    researchReplys,
    labelQuestion,
    Spinner,
    ces,
    CountryFlag,
    likertEmotion,
    idxSkeleton,
  },
  props: ['enable','token'],
  data: () => ({
    audio: null,
    enabledAudioResponse: false,
    headers: {
      'X-Custom-Header': 'somedata',
    },
    anonymousResponse: false,
    researchInfo: {
      reply: {},
      additionalQuestions: [],
    },
    dataContact: {
      name: null,
      email: null,
      phone: null,
    },
    logo: null,
    error: false,
    loading: true,
    answer: {},
    feedback: '',
    apiRoot: null,
    apiServerless: null,
    loadingSubmit: false,
    errorMsg: null,
    displayRequiredFields: false,
    typeModalContact: false,
    answerId: null,
    validateFields: true,
    promotersGrades: [5, 4],
    passivesGrades: [3],
    detractorsGrades: [2, 1],
    closingMessage: {
      useLogo: false,
      html: null,
    },
    displayClosingMessage: false,
    promotersQuestion: null,
    neutralQuestion: null,
    detractorsQuestion: null,
    company: null,
    afterAnswer: false,
    text: null,
    question: null,
    questionHTML: null,
    myHTML: null,
    langView: null,
    showMessage: false,
    visitorId: null,
  }),
  methods: {
    ...mapActions('research', ['getInfo', 'setAnswer']),
    ...mapActions('actions', ['setTestNpsReview']),
    setLangView(locale) {
      this.langView = locale;

      if (this.langView === 'br') {
        this.text = this.researchInfo.text;
        this.question = this.researchInfo.action.question;
        this.questionHTML = this.researchInfo.action.questionHTML;
        this.myHTML = this.researchInfo.action.email.template.myHTML;
      }
      if (this.langView === 'us') {
        this.text = this.researchInfo.textEn;
        this.question = this.researchInfo.action.questionEn;
        this.questionHTML = this.researchInfo.action.questionHTMLEn;
        this.myHTML = this.researchInfo.action.email.template.myHTMLEn;
      }
      if (this.langView === 'es') {
        this.text = this.researchInfo.textEs;
        this.question = this.researchInfo.action.questionEs;
        this.questionHTML = this.researchInfo.action.questionHTMLEs;
        this.myHTML = this.researchInfo.action.email.template.myHTMLEs;
      }
    },
    isVisible(item, value) {
      if (item.logicalRuleEnabled && item.conditionalRule) {
        let res = false;
        switch (item.conditionalRule) {
          case 'equal': // igual
            if (item.type === 'MULTIPLE') {
              if (item.multipleType === 'radio') {
                res =
                  value.multipleValues === item.conditionalValue ? true : false;
              } else {
                res = value.multipleValues.includes(item.conditionalValue);
              }
            } else {
              res =
                Number(value.review) === item.conditionalValue ? true : false;
            }
            break;

          case 'differentThan': // diferente
            if (item.type === 'MULTIPLE') {
              if (item.multipleType === 'radio') {
                res =
                  value.multipleValues !== item.conditionalValue ? true : false;
              } else {
                res = value.multipleValues.includes(item.conditionalValue);
              }
            } else {
              res =
                Number(value.review) !== item.conditionalValue ? true : false;
            }
            break;

          case 'biggerThen': // maior que
            res = value.review > item.conditionalValue ? true : false;
            break;

          case 'greaterOrEqualTo': // maior ou igual
            res = value.review >= item.conditionalValue ? true : false;
            break;

          case 'lessThan': // menor que
            res = value.review < item.conditionalValue ? true : false;
            break;

          case 'lessThanOrEqualTo': // menor ou igual
            res = value.review <= item.conditionalValue ? true : false;
            break;

          default:
            break;
        }
        return res;
      }
      return false;
    },

    // eslint-disable-next-line
    getReview(value, indexPosition) {
      // const index = Number(value.position || indexPosition);
      const index = Number(value.position);
      const item = this.researchInfo.additionalQuestions[index];

      let gradeQuestion = null;

      if (
        this.researchInfo.additionalQuestions[index] &&
        this.researchInfo.additionalQuestions[index].answerText
      ) {
        this.researchInfo.additionalQuestions[index].answerText = value.review;
      }

      // force dom update
      if (item.type && item.type !== 'MULTIPLE' && item.type !== 'INPUT') {
        gradeQuestion = value.review;
      } else if (item.type && item.type === 'INPUT') {
        gradeQuestion = value.review ? value.review : value;
        this.researchInfo.additionalQuestions[index].answerText = value.review
          ? value.review
          : value;
      } else {
        gradeQuestion = value.multipleValues;
      }

      this.$set(
        this.researchInfo.additionalQuestions[index],
        'gradeAddQuestion',
        gradeQuestion,
      );

      if (item.idsDisabled && item.idsDisabled.length > 0) {
        item.idsDisabled.forEach((el) => {
          for (
            let i = 0;
            i < this.researchInfo.additionalQuestions.length;
            i += 1
          ) {
            if (this.researchInfo.additionalQuestions[i].id === el) {
              this.researchInfo.additionalQuestions[i].show = this.isVisible(
                item,
                value,
              );
            }
          }
        });

        const arr = this.researchInfo.additionalQuestions;
        this.researchInfo.additionalQuestions = [];
        this.researchInfo.additionalQuestions = arr;
      }
    },

    callback(ev) {
      if (ev.blob) {
        this.audio = ev.blob;
      }
    },
    async blobToBase64(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    conditionalQuestion() {
      if (this.promotersGrades.includes(this.testNpsReview)) {
        return 'promotor';
      } else if (this.detractorsGrades.includes(this.testNpsReview)) {
        return 'detrator';
      }

      return 'neutro';
    },

    async submit() {
      this.loadingSubmit = true;
      const validate = this.verifyFields();

      if (validate) {
        let channel;
        switch (this.researchInfo.channel) {
          case 'E': {
            channel = 'email';
            break;
          }
          case 'S': {
            channel = 'sms';
            break;
          }
          case 'L': {
            channel = 'link';
            break;
          }
          case 'W': {
            channel = 'whatsapp';
            break;
          }
          default: {
            channel = 'email';
            break;
          }
        }
        this.answer.companyId = this.researchInfo.action.companyId;
        this.answer.name = this.dataContact.name;
        this.answer.email = this.dataContact.email;
        this.answer.phone = this.dataContact.phone;
        this.answer.review = this.testNpsReview;
        this.answer.feedback = this.feedback;
        this.answer.additionalQuestions = this.researchInfo.additionalQuestions;
        this.answer.channel = channel;
        this.answer.token = this.token;
        this.answer.anonymousResponse = !this.researchInfo.enableAnonymous
          ? this.researchInfo.enableAnonymous
          : this.anonymousResponse;

        if (this.audio) {
          this.answer.audioBase64 = await this.blobToBase64(this.audio);
        } else {
          this.answer.audioBase64 = null;
        }
        this.answer.deviceInfo = this.getDeviceInfo();
        this.answer.deviceInfo.visitorId = this.visitorId;
        this.answer.enableServerless = this.company.enableServerless;

        this.answer.additionalQuestions.forEach((el, index) => {
          if (this.langView === 'br') {
            el.text = el.text;
          } else if (this.langView === 'us') {
            el.text = el.textEN;
          } else if (this.langView === 'es') {
            el.text = el.textES;
          }
          if (el.addQuestionAnswer) {
            el.review = el.addQuestionAnswer.review;
            el.comment = el.addQuestionAnswer.comment || undefined;
            el.conditionalQuestion = this.getConditionalQuestion(el);
          }

          el.conditionalQuestion = this.getConditionalQuestion(el);

          delete this.answer.additionalQuestions[index].addQuestionAnswer;

          if (el.addQuestionAnswerMultiple) {
            el.multipleValues =
              el.addQuestionAnswerMultiple.multipleValues || [];
            el.comment = el.addQuestionAnswerMultiple.comment || undefined;
            el.conditionalQuestion = this.getConditionalQuestion(el);
          }

          delete this.answer.additionalQuestions[index]
            .addQuestionAnswerMultiple;
        });

        try {
          const response = await this.setAnswer(this.answer);
          this.answerId = response._id;
          if (!this.typeModalContact) {
            this.displayClosingMessage = true;
          }
          this.handleClosingMessage();
        } catch (error) {
          window.console.log(error);
          swal(
            this.$t('researchPage.errorMsg.title'),
            this.$t('researchPage.errorMsg.description'),
            'error',
          );
        }
      } else {
        swal('Oops...', this.errorMsg, 'warning');
      }

      EventBus.$emit('scroll-div', null);
      this.loadingSubmit = false;
    },

    async updateContactInfo() {
      if (
        this.dataContact.email &&
        !validator.isEmail(this.dataContact.email)
      ) {
        swal(
          this.$t('researchPage.errorMsg.title'),
          'Insira um e-mail válido',
          'warning',
        );
      } else {
        // serverless test
        if (this.company.enableServerless && this.apiServerless) {
          await axios.put(
            `${this.apiServerless}/answer/data-contact/${this.answerId}`,
            {
              name: this.dataContact.name,
              email: this.dataContact.email,
              phone: this.dataContact.phone,
            },
          );
        } else {
          await api.put(`/answer/data-contact/${this.answerId}`, {
            name: this.dataContact.name,
            email: this.dataContact.email,
            phone: this.dataContact.phone,
          });
        }

        this.displayClosingMessage = true;
      }
    },

    fillArray() {
      const arr = [];

      this.researchInfo.additionalQuestions.forEach((el) => {
        if (el.selectedProfile) {
          if (
            this.promotersGrades.includes(this.testNpsReview) &&
            el.selectedProfile.includes('promotor')
          ) {
            arr.push({
              answerText: el.answerText,
              applicableEnabled: el.applicableEnabled,
              commentEnabled: el.commentEnabled,
              profileEnabled: el.profileEnabled,
              review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
              selectedProfile: el.selectedProfile,
              text: el.text,
              type: el.type,
              addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
              choices: el.choices,
              indicatorValue: el.indicatorValue,
              indicatorValueEnabled: el.indicatorValueEnabled,
              selectedIndicator: el.selectedIndicator,
              feedback: el.feedback,
              mandatory: el.mandatory,
              id: el.id,
            });
          } else if (
            this.passivesGrades.includes(this.testNpsReview) &&
            el.selectedProfile.includes('neutro')
          ) {
            arr.push({
              answerText: el.answerText,
              applicableEnabled: el.applicableEnabled,
              commentEnabled: el.commentEnabled,
              profileEnabled: el.profileEnabled,
              review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
              selectedProfile: el.selectedProfile,
              text: el.text,
              type: el.type,
              addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
              choices: el.choices,
              indicatorValue: el.indicatorValue,
              indicatorValueEnabled: el.indicatorValueEnabled,
              selectedIndicator: el.selectedIndicator,
              feedback: el.feedback,
              mandatory: el.mandatory,
              id: el.id,
            });
          } else if (
            this.detractorsGrades.includes(this.testNpsReview) &&
            el.selectedProfile.includes('detrator')
          ) {
            arr.push({
              answerText: el.answerText,
              applicableEnabled: el.applicableEnabled,
              commentEnabled: el.commentEnabled,
              profileEnabled: el.profileEnabled,
              review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
              selectedProfile: el.selectedProfile,
              text: el.text,
              type: el.type,
              addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
              choices: el.choices,
              indicatorValue: el.indicatorValue,
              indicatorValueEnabled: el.indicatorValueEnabled,
              selectedIndicator: el.selectedIndicator,
              feedback: el.feedback,
              mandatory: el.mandatory,
              id: el.id,
            });
          }
        } else if (
          el.selectedProfile === null ||
          el.selectedProfile === undefined
        ) {
          arr.push({
            answerText: el.answerText,
            applicableEnabled: el.applicableEnabled,
            commentEnabled: el.commentEnabled,
            profileEnabled: el.profileEnabled,
            review: el.addQuestionAnswer ? el.addQuestionAnswer.review : null,
            selectedProfile: el.selectedProfile,
            text: el.text,
            type: el.type,
            addQuestionAnswerMultiple: el.addQuestionAnswerMultiple,
            choices: el.choices,
            indicatorValue: el.indicatorValue,
            indicatorValueEnabled: el.indicatorValueEnabled,
            selectedIndicator: el.selectedIndicator,
            feedback: el.feedback,
            mandatory: el.mandatory,
            id: el.id,
          });
        }
      });

      return arr;
    },

    verifyFields() {
      this.errorMsg = null;

      if (this.researchInfo.allAnswersRequired) {
        let isValid = true;
        const arr = this.fillArray();

        for (let i = 0; i < arr.length; i += 1) {
          const question = arr[i];

          const showQuestion = this.indicatorValuedQuestion(question);
          if (showQuestion) {
            const existOnDom = document.getElementById(question.id);
            if (
              !question.review &&
              question.review !== 0 &&
              question.type !== 'MULTIPLE' &&
              question.type !== 'LABEL' &&
              question.type !== 'INPUT' &&
              question.type !== 'CONTACT'
            ) {
              isValid = false;
              break;
            }
            if (question.type !== 'LABEL') {
              if (question.type === 'MULTIPLE') {
                if (
                  existOnDom &&
                  question.addQuestionAnswerMultiple.multipleValues.length <= 0
                ) {
                  isValid = false;
                  this.validateFields = false;
                  break;
                }
              } else if (question.type === 'INPUT') {
                if (existOnDom && !question.answerText) {
                  isValid = false;
                  this.validateFields = false;
                  break;
                }
              } else if (question.type === 'CONTACT') {
                const contactTypes = question.choices || [];
                const hasName = contactTypes.indexOf('name');
                const hasEmail = contactTypes.indexOf('email');
                const hasPhone = contactTypes.indexOf('phone');
                if (question.displayType === 'formSearch') {
                  if (hasName >= 0 && !this.dataContact.name) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }
                  if (hasEmail >= 0 && !this.dataContact.email) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }
                  if (hasPhone >= 0 && !this.dataContact.phone) {
                    isValid = false;
                    this.validateFields = false;
                    break;
                  }
                }
              } else if (
                this.testNpsReview === null ||
                this.testNpsReview === undefined
              ) {
                isValid = false;
                this.validateFields = false;
                break;
              }
            }
          }
        }

        if (!this.feedback) {
          isValid = false;
          this.validateFields = false;
        }

        if (!isValid) {
          this.errorMsg = 'Por favor, preencha todos os campos obrigatórios.';
          this.displayRequiredFields = true;
        }
      }

      if (this.researchInfo.customMandatoryQuestion) {
        let isValid = true;

        let arr = [];

        arr = this.fillArray();

        let fields = [];

        arr.forEach((element) => {
          if (element.type !== 'REVIEWS') {
            fields = arr.filter(
              (item) => item.mandatory && item.review === null,
            );
          }
        });

        if (fields.length) {
          this.showMessage = true;
        } else {
          this.showMessage = false;
        }

        for (let i = 0; i < arr.length; i += 1) {
          const question = arr[i];

          const showQuestion = this.indicatorValuedQuestion(question);

          if (showQuestion) {
            const existOnDom = document.getElementById(question.id);
            if (
              !question.review &&
              question.review !== 0 &&
              question.type !== 'MULTIPLE' &&
              question.type !== 'LABEL' &&
              question.type !== 'INPUT' &&
              question.type !== 'CONTACT' &&
              question.mandatory
            ) {
              this.validateFields = false;
              isValid = false;
              break;
            }
            if (question.type !== 'LABEL') {
              if (question.type === 'MULTIPLE') {
                if (
                  existOnDom &&
                  question.addQuestionAnswerMultiple.multipleValues.length <= 0
                ) {
                  this.validateFields = false;
                  isValid = false;
                  break;
                }
              } else if (
                existOnDom &&
                question.mandatory &&
                question.type === 'INPUT'
              ) {
                if (!question.answerText) {
                  this.validateFields = false;
                  isValid = false;
                  break;
                }
              } else if (question.type === 'CONTACT') {
                const contactTypes = question.choices || [];
                const hasName = contactTypes.indexOf('name');
                const hasEmail = contactTypes.indexOf('email');
                const hasPhone = contactTypes.indexOf('phone');

                if (question.displayType === 'formSearch') {
                  if (hasName >= 0 && !this.dataContact.name) {
                    this.validateFields = false;
                    isValid = false;
                    break;
                  }

                  if (hasEmail >= 0 && !this.dataContact.email) {
                    this.validateFields = false;
                    isValid = false;
                    break;
                  }

                  if (hasPhone >= 0 && !this.dataContact.phone) {
                    this.validateFields = false;
                    isValid = false;
                    break;
                  }
                }
              } else if (
                this.testNpsReview === null ||
                this.testNpsReview === undefined
              ) {
                this.validateFields = false;
                isValid = false;
                break;
              }
            }
          }
        }

        // if (!this.feedback) {
        //   isValid = false;
        //   this.validateFields = false;
        // }

        if (!isValid) {
          this.errorMsg = 'Por favor, preencha todos os campos obrigatórios.';
        }
      }

      if (!Number.isInteger(this.testNpsReview)) {
        this.errorMsg =
          'Por favor, responda nossa pergunta principal para enviar a resposta.';
      }
      if (
        this.researchInfo.metric === 'nps-0-10' &&
        this.testNpsReview < 0 &&
        this.testNpsReview > 10
      ) {
        this.errorMsg =
          'Por favor, responda nossa pergunta principal para enviar a resposta.';
      }
      if (
        this.researchInfo.metric === 'nps-1-5' &&
        this.testNpsReview < 1 &&
        this.testNpsReview > 5
      ) {
        this.errorMsg =
          'Por favor, responda nossa pergunta principal para enviar a resposta.';
      }
      if (this.errorMsg) {
        this.validateFields = false;
        return false;
      }
      this.validateFields = true;
      return true;
    },

    handleClosingMessage() {
      if (
        this.researchInfo.closingMessageEnabled &&
        this.researchInfo.closingMessage
      ) {
        if (this.researchInfo.closingMessage.dynamic) {
          if (
            this.researchInfo.closingMessage.promoters &&
            this.promotersGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo = this.researchInfo.closingMessage.promoters.useLogo;
            this.closingMessage.html = this.researchInfo.closingMessage.promoters.html;
          } else if (
            this.researchInfo.closingMessage.passives &&
            this.passivesGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo = this.researchInfo.closingMessage.passives.useLogo;
            this.closingMessage.html = this.researchInfo.closingMessage.passives.html;
          } else if (
            this.researchInfo.closingMessage.detractors &&
            this.detractorsGrades.includes(this.testNpsReview)
          ) {
            this.closingMessage.useLogo = this.researchInfo.closingMessage.detractors.useLogo;
            this.closingMessage.html = this.researchInfo.closingMessage.detractors.html;
          }
        } else if (this.researchInfo.closingMessage.default) {
          this.closingMessage.useLogo = this.researchInfo.closingMessage.default.useLogo;
          this.closingMessage.html = this.researchInfo.closingMessage.default.html;

          if (this.langView === 'us') {
            this.closingMessage.html = this.researchInfo.closingMessage.closingMessageEn;
          } else if (this.langView === 'es') {
            this.closingMessage.html = this.researchInfo.closingMessage.closingMessageEs;
          }
        }

        if (this.closingMessage.html) {
          this.closingMessage.html = this.closingMessage.html.replace(
            /<img src/gi,
            '<img style="max-width: 100%;" src',
          );
        }
      }
    },

    getConditionalQuestion(questions) {
      if (questions.profileEnabled) {
        return questions.selectedProfile;
      }

      return null;
    },

    getDeviceInfo() {
      let deviceInfo = null;
      try {
        deviceInfo = bowser.parse(window.navigator.userAgent);
      } catch (error) {
        window.console.log(error);
      }
      return deviceInfo;
    },

    async loadDeviceUUID() {
      const useFingerprintJS = false;
      if(useFingerprintJS){
        const fpPromise = FingerprintJS.load();
        const fp = await fpPromise;
        const result = await fp.get();
        this.visitorId = result.visitorId;
      } else {
        // Obter informações do navegador
        const browserInfo = {
          userAgent: navigator.userAgent,
          cooke: document.cookie
        };

        // Obter informações de resolução
        const resolution = {
          screenWidth: screen.width,
          screenHeight: screen.height,
          devicePixelRatio: window.devicePixelRatio
        };

        // Combinar informações em um objeto
        const hashInfo = {
          browser: browserInfo,
          resolution: resolution
        };

        // Codificar o objeto em uma string JSON e depois em base64
        const hash = btoa(JSON.stringify(hashInfo));

        this.visitorId = hash;
      }
    },

    replaceTagsOnText(researchInfo, value) {
      const arrayOfTags = [];
      arrayOfTags.push(
        {
          key: 'nota',
          value: value ? value : this.$route.params.grade,
        },
        {
          key: 'pnota',
          value: value ? value : this.$route.params.grade,
        },
      );
      let promoters = researchInfo.reply.promoters;
      let neutral = researchInfo.reply.neutral;
      let detractors = researchInfo.reply.detractors;
      arrayOfTags.forEach((tag) => {
        const regexTags = new RegExp(`<${tag.key}>`, 'gi');
        if (tag.value === ' ') {
          tag.value = 0;
        }
        if (promoters) {
          promoters = promoters.replace(
            regexTags,
            tag.value ? tag.value : this.$route.params.grade,
          );
          this.promotersQuestion = promoters;
        }
        if (neutral) {
          neutral = neutral.replace(
            regexTags,
            tag.value ? tag.value : this.$route.params.grade,
          );
          this.neutralQuestion = neutral;
        }
        if (detractors) {
          detractors = detractors.replace(
            regexTags,
            tag.value ? tag.value : this.$route.params.grade,
          );
          this.detractorsQuestion = detractors;
        }
      });
    },
    indicatorValuedQuestion(item) {
      if (item.indicatorValueEnabled) {
        for (let i = 0; i < this.researchInfo.indicators.length; i += 1) {
          if (item.indicatorCriterion === 'equal') {
            if (
              this.researchInfo.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.researchInfo.indicators[i].value.toLowerCase() ===
                item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'different') {
            if (
              this.researchInfo.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.researchInfo.indicators[i].value.toLowerCase() !==
                item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'contains') {
            if (
              this.researchInfo.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.researchInfo.indicators[i].value
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '') // remove accents
                  .toLowerCase()
                  .includes(
                    item.indicatorValue
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .toLowerCase(),
                  )
              ) {
                return true;
              }
              break;
            }
          }
        }
        return false;
      }
      return true;
    },
  },
  computed: {
    ...mapState('actions', ['testNpsReview']),
  },
  watch: {
    testNpsReview: function watchGrade(value) {
      this.replaceTagsOnText(this.researchInfo, value);
    },
  },
  async created() {
    this.apiRoot = process.env.API_ROOT;
    this.apiServerless = process.env.API_SERVERLESS;
    try {

      // const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVLZXkiOiJpTURpb25sSCIsImlhdCI6MTY2MjEyMTU1OSwiZXhwIjoxNjY5ODk3NTU5fQ.Ujby9NsMdCcRwvO_TOv5hvUBGMieBduwIcFauLNZIPk';
      const response = await this.getInfo(this.token);
      this.researchInfo = response;

      const companyData = await api.get(
        `/surveys/companies/${this.researchInfo.action.companyId}`,
      );
      this.company = companyData.data;

      if (this.researchInfo.enabledAudioResponse) {
        this.enabledAudioResponse = true;
      }

      if (this.researchInfo.action.allAnswersAnonymous) {
        this.anonymousResponse = true;
      }
      this.$store.state.actions.action = this.researchInfo.action;
      this.replaceTagsOnText(this.researchInfo);
      this.setTestNpsReview(parseInt(this.$route.params.grade, 10));
      this.researchInfo.additionalQuestions.forEach((el) => {
        if (el.type === 'MULTIPLE') {
          el.addQuestionAnswerMultiple = {
            multipleValues: [],
            comment: null,
          };
        } else if (el.type === 'INPUT') {
          el.answerText = null;
        } else if (el.type === 'CONTACT') {
          if (el.displayType === 'afterSendAnswer') {
            this.typeModalContact = true;
          }
        } else {
          el.addQuestionAnswer = {
            review: null,
            comment: null,
          };
        }
      });
      if (this.researchInfo.metric.includes('0-10')) {
        this.promotersGrades = [10, 9];
        this.passivesGrades = [8, 7];
        this.detractorsGrades = [6, 5, 4, 3, 2, 1, 0];
      }

      if (this.researchInfo.metric === 'like-dislike') {
        this.promotersGrades = [1];
        this.detractorsGrades = [0];
      }

      const logoUrl = process.env.INDECX_FILES_BUCKET;
      this.logo = `${logoUrl}/${response.logo}`;

      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.error = error.response.data.message;
    }

    this.langView = this.$route.query.lang || 'br';

    if (this.langView === 'br') {
      this.text = this.researchInfo.text;
      this.question = this.researchInfo.action.question;
      this.questionHTML = this.researchInfo.action.questionHTML;
      this.myHTML = this.researchInfo.action.email.template.myHTML;
    }
    if (this.langView === 'us') {
      this.text = this.researchInfo.textEn;
      this.question = this.researchInfo.action.questionEn;
      this.questionHTML = this.researchInfo.action.questionHTMLEn;
      this.myHTML = this.researchInfo.action.email.template.myHTMLEn;
    }
    if (this.langView === 'es') {
      this.text = this.researchInfo.textEs;
      this.question = this.researchInfo.action.questionEs;
      this.questionHTML = this.researchInfo.action.questionHTMLEs;
      this.myHTML = this.researchInfo.action.email.template.myHTMLEs;
    }
  },
  mounted() {
    this.loadDeviceUUID();
  },
}
</script>


<style lang="scss" scoped>
    @import '@/themes/default/variables.scss';
    .loadingSubmit {
      position: fixed;
      z-index: 99999;
      height: 50%;
      width: 2em;
      overflow: visible;
      margin: auto;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      opacity: 1;
    }

    .sk-wave {
      width: 50px;
      height: 180px;
      text-align: center;
      font-size: 10px;
    }

    .dark-mode {
      filter: brightness(50%);
    }

    .closing-message-area {
      display: flex;
      flex-direction: column;
      i {
        font-size: 92px;
        color: #009bdb;
      }
      h4 {
        color: #009bdb;
      }
    }
    .error-area {
      display: flex;
      flex-direction: column;
      i {
        font-size: 92px;
        color: #009bdb;
      }
      h4 {
        color: #009bdb;
      }
    }

    .container {
      min-height: 100vh;
      background-color: #fff;
    }
    .question {
      font-size: 1.1rem;
    }
    .required {
      color: red;
      font-size: 12px;
    }
    </style>



// WEBPACK FOOTER //
// src/components/organisms/call-center/research.vue